<div class="legal-page">
  <div class="legal-inner">
    <header class="legal-head">
      <h1>Condizioni d’uso e diritti sulle immagini</h1>
      <p class="legal-updated">Ultimo aggiornamento: ottobre 2026</p>
    </header>

    <section class="legal-panel">
      <h2>1. Premessa</h2>
      <p>
        Le presenti condizioni regolano l’utilizzo del sito dell’Archivio della
        Misericordia di Borgo San Lorenzo e, in particolare, la consultazione
        delle riproduzioni digitali di documenti, atti e immagini ivi
        pubblicate. Per il trattamento dei dati personali si rinvia
        all’<a routerLink="/privacy">Informativa sulla privacy</a>.
      </p>
    </section>

    <section class="legal-panel">
      <h2>2. Titolarità dei contenuti</h2>
      <p>
        I documenti, gli atti e le relative riproduzioni fotografiche o digitali
        presenti sull’Archivio sono di proprietà o comunque nella disponibilità
        della
        <strong>Confraternita di Misericordia di Borgo San Lorenzo</strong>
        (di seguito “Misericordia”), salvo diversa indicazione. Sono materiali
        dell’archivio storico e istituzionale della Misericordia e non
        costituiscono contenuto liberamente riutilizzabile.
      </p>
    </section>

    <section class="legal-panel">
      <h2>3. Consultazione consentita</h2>
      <p>
        L’utente autorizzato può consultare i contenuti esclusivamente per le
        finalità di studio, ricerca storica, documentazione e fruizione
        culturale connesse all’Archivio, nel rispetto delle presenti condizioni
        e delle autorizzazioni eventualmente rilasciate dalla Misericordia.
      </p>
    </section>

    <section class="legal-panel">
      <h2>4. Filigrana e misure di protezione</h2>
      <p>
        Le immagini possono essere corredate di filigrana o di altre misure
        tecniche e organizzative volte a identificarne la provenienza e a
        prevenirne usi non autorizzati. La rimozione, l’oscuramento o
        l’alterazione della filigrana o di tali misure è vietata.
      </p>
    </section>

    <section class="legal-panel">
      <h2>5. Usi vietati</h2>
      <p>Salvo autorizzazione scritta della Misericordia, è vietato:</p>
      <ul>
        <li>
          riprodurre, scaricare in modo sistematico, copiare, modificare,
          pubblicare o diffondere le immagini e i documenti;
        </li>
        <li>
          utilizzarli per finalità commerciali, pubblicitarie o comunque
          estranee alla consultazione culturale e di studio;
        </li>
        <li>
          utilizzarli per scopi illeciti, denigratori, fraudolenti o comunque
          lesivi della Misericordia, di terzi o della dignità delle persone
          eventualmente raffigurate o citate;
        </li>
        <li>
          rimuovere indicazioni di provenienza, filigrane o metadati
          identificativi;
        </li>
        <li>
          aggirare limiti tecnici di accesso, di visualizzazione o di
          protezione dei contenuti.
        </li>
      </ul>
    </section>

    <section class="legal-panel">
      <h2>6. Richiesta di autorizzazione</h2>
      <p>
        Per usi diversi dalla semplice consultazione (ad esempio pubblicazione,
        mostre, riproduzioni editoriali o altri riusi) è necessario ottenere
        preventiva autorizzazione dalla Misericordia, contattando:
      </p>
      <ul>
        <li>
          email
          <a href="mailto:home@misericordia.net">home&#64;misericordia.net</a>
        </li>
        <li>
          PEC
          <a href="mailto:misericordiabsl@legalmail.it">misericordiabsl&#64;legalmail.it</a>
        </li>
        <li>tel. <a href="tel:0558494118">055 8494118</a></li>
      </ul>
      <p>
        La richiesta deve indicare finalità, modalità e contesto d’uso. La
        Misericordia può concedere, negare o subordinare l’autorizzazione a
        condizioni specifiche.
      </p>
    </section>

    <section class="legal-panel">
      <h2>7. Responsabilità dell’utente</h2>
      <p>
        L’utente è responsabile dell’uso che fa dei contenuti consultati e si
        impegna a rispettare la normativa vigente, i diritti della Misericordia
        e i diritti di eventuali terzi. L’eventuale violazione può comportare
        la sospensione dell’accesso e le azioni tutelative previste dalla
        legge.
      </p>
    </section>

    <section class="legal-panel">
      <h2>8. Aggiornamenti</h2>
      <p>
        Le presenti condizioni possono essere aggiornate. La versione corrente
        è pubblicata su questa pagina con indicazione della data di revisione.
      </p>
    </section>
  </div>
</div>
